<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">
          <div
            :class="[item.id == type ? 'title-active' : '']"
            @click="handleType(item)"
            v-for="item in typeArr"
            :key="item.id"
          >
            兑换码核销
          </div>
        </div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over" v-if="type == 1">
        <el-input v-model="exchangecode" placeholder="请输入卡券兑换码"></el-input>
      </div>
      <div class="posi-over posi-over-img" v-if="type==2">
        <img :src="qrcode" alt="" />
        <div>手机扫描二维码核销</div>
      </div>
      <div class="posi-btn" v-if="type == 1">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
        <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      typeArr: [
        {
          id: 1,
          name: "兑换码核销",
        },
        {
          id: 2,
          name: "二维码核销",
        },
      ],
      type: 1,
      exchangecode:"",
      id:"",
      qrcode:""
    };
  },
  mounted() {},
  methods: {
    handleType(item) {
      this.type = item.id;
    },
    //提交
    async handleSubmit() {
      let res = await this.$api.shopSetcheck({
        id: this.id,
        exchangecode:this.exchangecode
      });
      if (res.code == 1) {
        this.$message.success("开通成功");
        let obj = {
          flag: false,
          submitFlag: true,
        };
        this.$emit("writeOffCell", obj);
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("writeOffCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
            this.id = newVal.id;
            this.qrcode = newVal.qrcode;
        }
      },
      deep: true,
    },
  },
};
</script>
        <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 618px;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  padding-bottom: 40px;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 0px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 16px;
      font-weight: 400;
      color: #202224;
      display: flex;
      div {
        width: 132px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        cursor: pointer;
      }
      .title-active {
        background-color: #fff;
      }
      //   &:hover {
      //     background-color: #fff;
      //   }
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .posi-over-img {
    text-align: center;
    font-size: 14px;
    color: #AEAEB2;
    img {
      width: 200px;
      height: 200px;
    }
  }
  /deep/.posi-over {
    overflow: auto;
    padding: 40px 83px 53px;

    .el-select {
      width: 100%;
    }
    input {
      width: 100%;
      height: 52px;
      background-color: #f5f6fa;
      //   color: #a6a6a6;
      color: #000;
      font-size: 14px;
      border: 1px solid #f5f6fa;
      outline: none;
      padding-left: 16px;
    }
    .el-input__inner {
      height: 52px;
      line-height: 52px;
      background-color: #f5f6fa;
      color: #000;
      font-size: 14px;
      border: 1px solid #f5f6fa;
    }
  }
  .posi-btn {
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #4a4b9d;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>